<template>
	<v-container class="noMargin">			
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PROJECTS') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>PROJECTS</h2>					
				</div>	
				<v-btn @click.prevent="fncAddProject" class="elevation-5" color="info">Create Project</v-btn>
                <v-btn @click.prevent="fncReloadProjects" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
			</v-flex>
		</v-layout>		
    </v-container>	
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
			fncAddProject() {
				var modalDetails = { title: 'Add Project', component: 'modal-project-add', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
            },
            fncReloadProjects() {
              this.$store.commit('fncEmptyProjects');
              this.$store.dispatch({
                type: 'fncPopulateProjectList',
                reload: true
              })
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'
			])
		}
	}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>